import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const FeatureManagementRoute = lazyWithRetries(() => import('./index'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.featureManagement(),
    element: (
      <StandardPageLayout
        maxWidth={900}
        title={<T _str="Feature management" />}
        elementId="featureManagementRoute">
        <Suspense fallback={<RouteLoading />}>
          <FeatureManagementRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
